import React from 'react';
import { WidgetLayout } from '../shared/WidgetLayout/WidgetLayout';
import { WidgetButton } from '../shared/WidgetButton/WidgetButton';
import { CardLayout } from '../shared/CardLayout/CardLayout';
import { Box, Text } from '@wix/design-system';
import { WithMarkdown } from '../shared/WithMarkdown/WithMarkdown';
import { Icons } from '../shared/Icons';
import s from './PlansWidget.module.scss';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
export const PlansWidget = _ref => {
  var _data$options, _data$options2, _data$options3, _data$secondaryButton, _data$primaryButton;
  let {
    data,
    context,
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(PLANS_WIDGET, onWidgetActionData, data.text);
    };
    return handler;
  };
  const cards = (_data$options = data.options) == null ? void 0 : _data$options.map(option => {
    var _option$button, _option$button2, _option$button3, _option$button4, _option$button5, _option$button6, _option$button7, _option$button8, _option$list, _option$list2;
    return /*#__PURE__*/React.createElement(CardLayout, null, /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP2"
    }, /*#__PURE__*/React.createElement(Box, {
      align: "space-between",
      gap: "SP1"
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "normal"
    }, option.title), /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "thin",
      secondary: true,
      light: true,
      className: s.optionSubtitle
    }, /*#__PURE__*/React.createElement(WithMarkdown, null, option.subtitle))), (option == null || (_option$button = option.button) == null ? void 0 : _option$button.label) && /*#__PURE__*/React.createElement(WithDisabledControl, {
      isDisabled: areControlsDisabled,
      onEnable: enableControls,
      t: context.t
    }, /*#__PURE__*/React.createElement(WidgetButton, {
      context: context,
      webAction: option == null || (_option$button2 = option.button) == null ? void 0 : _option$button2.webAction,
      selectedValues: [option.value],
      selectedTitles: [option.title],
      respondText: option == null || (_option$button3 = option.button) == null ? void 0 : _option$button3.respondText,
      icon: option == null || (_option$button4 = option.button) == null ? void 0 : _option$button4.icon,
      sideEffect: option == null || (_option$button5 = option.button) == null ? void 0 : _option$button5.sideEffect,
      onClick: handleButtonClick('option_button_click', option == null || (_option$button6 = option.button) == null ? void 0 : _option$button6.label),
      skin: option == null || (_option$button7 = option.button) == null ? void 0 : _option$button7.skin,
      disabled: areControlsDisabled
    }, option == null || (_option$button8 = option.button) == null ? void 0 : _option$button8.label))), (option == null || (_option$list = option.list) == null ? void 0 : _option$list.length) && /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP1"
    }, option == null || (_option$list2 = option.list) == null ? void 0 : _option$list2.map(item => {
      var _item$icon;
      return /*#__PURE__*/React.createElement(Box, {
        gap: "SP1",
        verticalAlign: "top"
      }, /*#__PURE__*/React.createElement("div", {
        className: s.icon,
        style: {
          // @ts-expect-error
          '--icon-color': getIconColor({
            icon: item.icon
          })
        }
      }, getIconElement(item == null || (_item$icon = item.icon) == null ? void 0 : _item$icon.name)), /*#__PURE__*/React.createElement(WithMarkdown, null, item.text));
    }))));
  });
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    text: data.text,
    secondaryButton: data.secondaryButton,
    primaryButton: data.primaryButton,
    context: context,
    selectedValues: ((_data$options2 = data.options) == null ? void 0 : _data$options2.map(option => option.value)) ?? [],
    selectedTitles: ((_data$options3 = data.options) == null ? void 0 : _data$options3.map(option => option.title)) ?? [],
    onSecondaryButtonClick: handleButtonClick('secondary_button_click', (_data$secondaryButton = data.secondaryButton) == null ? void 0 : _data$secondaryButton.label),
    onPrimaryButtonClick: handleButtonClick('primary_button_click', (_data$primaryButton = data.primaryButton) == null ? void 0 : _data$primaryButton.label),
    footerButtonsAsColumn: data.footerButtonsAsColumn,
    bottomText: data.bottomText,
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, cards);
};
export const PLANS_WIDGET = 'PLANS_WIDGET';
function getIconElement(iconName) {
  const IconElement = Icons[iconName ?? 'Confirm'];
  return /*#__PURE__*/React.createElement(IconElement, null);
}
function getIconColor(_ref2) {
  let {
    icon
  } = _ref2;
  if (icon != null && icon.color) {
    return icon.color;
  } else if (icon != null && icon.name && icon.name !== 'Confirm') {
    return 'black';
  } else {
    return '#229954';
  }
}
//# sourceMappingURL=PlansWidget.js.map